// Inner Child Model page — no FullCalendar, no duplicate contact/index import
import WorkshopInitializer from '../../components/WorkshopInitializer.js';
import ReadMoreToggle from '../../components/readmore.js';
import EventFilter from '../../components/EventFilter.js';
import { initInstallmentAutoOpen } from '../../components/installment-auto-open.js';
import { domReady } from '../../utils/dom.js';

function initWorkshopAppIfPresent() {
  if (!document.getElementById('icm-data')) return null;

  if (!window.workshopApp) {
    window.workshopApp = new WorkshopInitializer();
    window.dispatchEvent(new CustomEvent('workshopApp:ready', { detail: window.workshopApp }));
  }
  return window.workshopApp;
}

initInstallmentAutoOpen();

domReady(() => {
  initWorkshopAppIfPresent();
  new ReadMoreToggle();

  if (document.querySelector('.icm-events')) {
    new EventFilter({
      containerSelector: '.icm-events',
      itemSelector: '.icm-group',
      visibleCountId: 'visible-icm-count',
      totalCountId: 'total-icm-count',
    });
  }
});
